
import { defineComponent, PropType } from 'vue';
import type { DropdownItems } from '@white-label-types/dropdown';
import IconButton from '@white-label-icon/icon-button';
import { arrowKeyNavigationMixin } from '@white-label-helper/shared-helpers';

export default defineComponent({
  name: 'DropdownList',
  components: {
    IconButton,
  },

  mixins: [arrowKeyNavigationMixin],

  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },

    items: {
      type: Array as PropType<DropdownItems>,
      required: true,
    },

    dropdownOpened: {
      type: Boolean,
      default: false,
    },

    mobilePopUpTitle: {
      type: String,
      required: false,
      default: '',
    },

    matchWidth: {
      type: Boolean,
      default: false,
    },

    isSearchable: {
      type: Boolean,
      default: false,
    },

    ariaLabelledby: {
      type: String,
      default: '',
    }
  },

  data() {
    return {
      activeIndex: -1,
    };
  },

  methods: {
    updateScrollPosition(): void {
      const dropdownListContent = this.$refs.dropdownContent;
      if (!dropdownListContent) {
        return;
      }

      const firstItemElement = dropdownListContent.querySelector('.dropdown-item');
      if (!firstItemElement) return;

      const currentActiveIndex = this.items.findIndex((item) => item.name === this.value);
      const lastIndex = this.items.length - 1;
      const itemHeight = firstItemElement.clientHeight;
      let scrollOffset = itemHeight * (currentActiveIndex - 1);

      if (currentActiveIndex === 0) {
        scrollOffset = 0;
      }

      if (currentActiveIndex === lastIndex) {
        scrollOffset = lastIndex * itemHeight;
      }

      dropdownListContent.scrollTop = scrollOffset;
    },

    closeDropdown(event: KeyboardEvent) {
      this.$emit('close');
      this.$emit('esc-pressed', event);
    }
  }
});
